import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './LegalPrivacyPage.scss';

export const LegalPrivacyPage: FC = (): ReactElement => (
    <Page className="legal-privacy-page">
        <ConnectedPageHelmet appRoute={AppRoute.legalPrivacy} />
        <ConnectedBlockRenderer appRoute={AppRoute.legalPrivacy} />
    </Page>
);
